import { render, staticRenderFns } from "./Recommendation.icon.vue?vue&type=template&id=2caa3ecb&"
import script from "./Recommendation.icon.vue?vue&type=script&lang=js&"
export * from "./Recommendation.icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports